module.exports = __webpack_public_path__ + "static/media/icons.f3279efc.svg";